import { inject, Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, filter, of, switchMap } from "rxjs";
import { BalanceService } from "./balance.service";
import { StorageService } from "./storage.service";

@Injectable({
  providedIn: "root",
})
export class ExRateService {
  readonly RATE_MULTIPLIER = 13;

  http = inject(HttpClient);
  exRate$ = new BehaviorSubject<any>(null);
  balanceService = inject(BalanceService);
  storage = inject(StorageService);

  constructor() {
    this.exRate$.next(this.getExRate());

    // Listen to app data changes from StorageService
    this.storage.appData$.subscribe((appData) => {
      if (appData && appData.user && appData.user.CURRENCY) {
        this.exRate$.next(this.getExRate());
      }
    });

    this.balanceService.balanceData$
      .pipe(
        filter(() => !this.getExRate()),
        switchMap((balanceData: any) => {
          if (balanceData) {
            return this.fetchRate({
              currency: balanceData?.CURRENCY_CODE,
            });
          }

          return of(balanceData);
        }),
      )
      .subscribe({
        next: (response) => {
          if (response?.status === "ok" && response?.result) {
            this.setExRate(JSON.stringify(response.result[0]));
          }
        },
      });
  }

  fetchRate(params?: any) {
    return this.http.get(`${environment.sURL}${environment.endpoints.rate}/${params.currency}`);
  }

  setExRate(data: string) {
    // sessionStorage.setItem("exRate", data);
    this.storage.setItem("exRate", data);
    this.updateExRate();
  }

  updateExRate(data?: any) {
    this.exRate$.next(data || this.getExRate());
  }

  clearExRate() {
    // sessionStorage.removeItem("exRate");
    this.storage.removeItem("exRate");
  }

  getExRate() {
    // const exRateData = sessionStorage.getItem("exRate");
    const exRateData = this.storage.getItem<any>("exRate");
    const balance = this.balanceService.getUserBalance();
    // const symbols = this.getSymbols();
    const symbol = this.getSymbol();
    const rate = +exRateData?.GET_EXCHANGE_RATE * this.RATE_MULTIPLIER;

    // console.log(symbols);
    if (exRateData != null) {
      if (exRateData?.GET_EXCHANGE_RATE && balance?.CURRENCY_CODE) {
        return {
          RATE: rate,
          CODE: balance?.CURRENCY_CODE,
          SYMBOL: symbol,
          // SYMBOL: symbols[balance?.CURRENCY_CODE],
        };
      }
    }

    return null;
  }

  setSymbols(symbols: any) {
    // sessionStorage.setItem("symbols", JSON.stringify(symbols));
    this.storage.setItem("symbols", symbols);
  }

  getSymbol() {
    const app = this.storage.getItem<any>("app");
    if (app && app.user && app.user.CURRENCY) {
      return app.user.CURRENCY;
    }
    return "";
  }

  getSymbols() {
    // const symbols = sessionStorage.getItem("symbols");
    const app = this.storage.getItem<any>("app");
    const symbols = app.user.CURRENCY;
    console.log(app, symbols);
    if (symbols !== null) return symbols;
    return {};
  }
}
